import React, { useEffect, useState } from "react";
import { Col, Flex, Row } from "antd";
import api from "../../api";
import Loader from "../../components/spin/Loader";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchStats = async () => {
    setLoading(true);
    const res = await api.get_stats();
    // console.log("dash --->", res);
    if (res.status === 200) {
      setData(res.data.data);
    } else {
      // console.error("Error fetching stats:", res);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const cellStyle = {
    background: "#f5f5f5",
    padding: "24px",
    textAlign: "center",
    borderRadius: 8,
    border: "1px solid #e0e0e0",
  };

  if (loading) return <Loader />;

  return (
    <Flex
      vertical
      align="flex-start"
      justify="flex-start"
      style={{ width: "100%", height: "100%" }}
    >
      <Row gutter={[16, 16]} style={{ width: "100%" }}>
        <Col xs={24} sm={12} md={8}>
          <div style={cellStyle}>
            <h4>Нийт сугалаа</h4>
            <p style={{ fontSize: "30px" }}>{data.totalLotteries}</p>
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div style={cellStyle}>
            <h4>Нийт үүссэн сугалааны дугаар</h4>
            <p style={{ fontSize: "30px" }}>{data.totalNumbers}</p>
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div style={cellStyle}>
            <h4>Нийт оролцогчид</h4>
            <p style={{ fontSize: "30px" }}>{data.totalParticipants}</p>
          </div>
        </Col>
      </Row>
    </Flex>
    // <Flex
    //   vertical
    //   align="center"
    //   justify="center"
    //   style={{ width: "100%", height: "100%" }}
    // >
    //   Тун удахгүй
    // </Flex>
  );
};

export default Dashboard;
